export default __webpack_public_path__ + "static/media/Mark-6-HUD-RT Capacity.bee8400f.jpg";